import { useEffect, useState } from 'react';
import cmsService from 'src/services/cms-service';

type CMSArticleData = {
    title: string;
    content: string;
} | null;

const useCMSArticle = (slug: string): CMSArticleData => {
    const [data, setData] = useState<CMSArticleData>(null);

    useEffect(() => {
        cmsService.getArticleBySlug(slug).then(result => {
            if (result) setData(result);
        });
    }, [slug]);

    return data;
};

export default useCMSArticle;
